// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Пропозиції проєктів» (Project proposals, ключ `pprop`, група `projects`). */
export const projectProposalsManifest: IModuleManifest = {
  key: 'pprop',
  group: 'projects',
  slug: 'project-proposals',
  prefix: 'PJP',
  name: { en: 'Project proposals', uk: 'Пропозиції проєктів' },
  entities: [
    { key: 'pprop', slug: 'pprop', name: { en: 'Project proposals', uk: 'Пропозиції проєктів' }, main: true },
  ],
  loadState: () => import('./state/projectProposalsSlice').then((m) => m.projectProposalsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
